import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { TestSubsection } from "./TestSection";
import { ShieldCheck, Calculator, Database } from "lucide-react";
import * as tests from "./testDefinitions";

export const IntegritySection = ({ testResults }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">System Integrity</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <TestSubsection
          icon={ShieldCheck}
          iconColor="text-red-600"
          title="Double Booking Prevention"
          tests={tests.doubleBookingTests}
          results={testResults.doubleBooking}
        />
        
        <TestSubsection
          icon={Calculator}
          iconColor="text-blue-600"
          title="Fee Calculations"
          tests={tests.feeCalculationsTests}
          results={testResults.feeCalculations}
        />
        
        <TestSubsection
          icon={Database}
          iconColor="text-purple-600"
          title="Data Consistency"
          tests={tests.dataConsistencyTests}
          results={testResults.dataConsistency}
        />
      </CardContent>
    </Card>
  );
};
